export const EMAIL = "hello@mrinalee.life";
export const INSTAGRAM_URL = "https://www.instagram.com/makeupandeverythingwithit";
export const INSTAGRAM_HANDLE = "@makeupandeverythingwithit";
export const YOUTUBE_URL = "https://www.youtube.com/@mrinaleemehta9899";

const U = (id, w) => `https://images.unsplash.com/${id}?q=85&w=${w}&auto=format&fit=crop`;
const P = (id, w) =>
  `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=${w}`;

export const IMAGES = {
  hero: U("photo-1770748146865-cd2c5c147518", 1600),
  portrait: P(30495792, 800),
};

export const SERVICES = [
  {
    title: "Bridal Makeup",
    tagline: "For the day every eye is on you.",
    copy: "Your wedding day deserves a look that feels unmistakably you — polished, radiant and camera-ready.",
    img: U("photo-1760080839478-6791bbad30fb", 800),
    alt: "Indian bride in traditional red wedding attire with bridal makeup",
  },
  {
    title: "Engagement & Reception",
    tagline: "The first chapter of your celebrations.",
    copy: "Refined glam designed for celebrations, photographs and unforgettable evenings.",
    img: P(36896552, 800),
    alt: "Indian bride in orange saree with floral jewelry and reception glam",
  },
  {
    title: "Haldi & Mehndi",
    tagline: "Sunlit mornings, marigold and laughter.",
    copy: "Fresh, glowing looks for daytime ceremonies — light on the skin, luminous in every candid.",
    img: P(37797086, 800),
    alt: "Bride with henna-adorned hands in a red saree at her mehndi",
  },
  {
    title: "Party & Occasion Makeup",
    tagline: "For evenings that deserve a little extra glow.",
    copy: "Beautiful, effortless glam for parties, celebrations and special occasions.",
    img: P(38796463, 800),
    alt: "Indian woman in traditional attire with occasion makeup outdoors",
  },
  {
    title: "Family & Friends",
    tagline: "Because everyone you love is in the frame.",
    copy: "Coordinated, camera-ready looks for mothers, sisters, bridesmaids and the whole wedding party.",
    img: U("photo-1714236854441-a6cd4be9ae3a", 800),
    alt: "Indian wedding celebration with family in traditional festive attire",
  },
  {
    title: "Editorial / Photoshoot",
    tagline: "For the lens, the lights and the pages.",
    copy: "Creative, polished makeup for fashion, portraits, campaigns and editorial shoots.",
    img: P(32107205, 800),
    alt: "South Asian editorial beauty portrait with henna art",
  },
];

export const CATEGORIES = ["All", "Bridal", "Glam", "Soft Glam", "Editorial"];

export const PORTFOLIO = [
  {
    id: "look-1",
    title: "Sindoor & Gold",
    category: "Bridal",
    url: U("photo-1695972774193-53c156726282", 900),
    description: "Classic red-and-gold bridal radiance with a skin-first glowing finish.",
  },
  {
    id: "look-2",
    title: "Heirloom Glow",
    category: "Soft Glam",
    url: P(24549086, 900),
    description: "Soft defined eyes, nath and maang tikka — tradition, gently lit.",
  },
  {
    id: "look-3",
    title: "Mehndi Editorial",
    category: "Editorial",
    url: P(22458409, 900),
    description: "Henna artistry and sculpted beauty for the camera.",
  },
  {
    id: "look-4",
    title: "Marigold Evening",
    category: "Glam",
    url: U("photo-1732812947857-de410a788a4d", 900),
    description: "Warm bronze tones and shimmering gold highlights for the evening.",
  },
  {
    id: "look-5",
    title: "Modern Maharani",
    category: "Bridal",
    url: U("photo-1697347815893-2cfa02e6cca8", 900),
    description: "Regal red bridal couture with a modern, luminous base.",
  },
  {
    id: "look-6",
    title: "Crimson Muse",
    category: "Editorial",
    url: U("photo-1697684459917-e91efb33a337", 900),
    description: "High-drama crimson styling with polished editorial precision.",
  },
  {
    id: "look-7",
    title: "Scarlet Hour",
    category: "Glam",
    url: U("photo-1695972775752-5e9a7d9f6d92", 900),
    description: "Warm scarlet glam made for sangeet nights and dance floors.",
  },
  {
    id: "look-8",
    title: "Morning Radiance",
    category: "Soft Glam",
    url: U("photo-1697684459863-308b1c497ff2", 900),
    description: "Featherlight base and a whisper of rose for daytime ceremonies.",
  },
];

export const INSTAGRAM_TILES = [
  "/insta1.jpg",
  "/insta2.jpg",
  "/insta3.jpg",
  "/insta4.jpg",
];

export const COMPARISONS = [
  {
    label: "Bridal Glam",
    before: P(36153394, 1000),
    after: U("photo-1695972774193-53c156726282", 1000),
  },
  {
    label: "Soft Glam",
    before: P(37319355, 1000),
    after: U("photo-1697684459863-308b1c497ff2", 1000),
  },
  {
    label: "Reception",
    before: P(37937140, 1000),
    after: U("photo-1732812947857-de410a788a4d", 1000),
  },
];

export const YOUTUBE_VIDEOS = [
  {
    id: "pK46kyVA6WE",
    tag: "Tutorial",
    title: "Soft Glam Makeup Tutorial",
  },
  {
    id: "OvVA48Oml-Q",
    tag: "Wedding Vlog",
    title: "3 Bridal Makeups at a Himachal Wedding",
  },
  {
    id: "yHiUHHdWrBM",
    tag: "Review",
    title: "Trying New Makeup — First Impressions",
  },
];

export const COURSES = [
  {
    title: "Personal Makeup Masterclass",
    level: "For you, on you",
    duration: "1 Day · 4–5 Hours",
    tagline: "Learn your own face.",
    copy: "A private, hands-on session designed around your features, your lifestyle and your own makeup bag — so every day can feel a little more polished.",
    learn: [
      "Skin prep and a base that actually lasts",
      "Everyday-to-evening eye looks, simplified",
      "Your perfect shades, textures and products",
      "Brushes, tools and hygiene essentials",
    ],
    img: "https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9?q=85&w=900&auto=format&fit=crop",
    alt: "Makeup brushes and products arranged for a personal makeup lesson",
  },
  {
    title: "Professional Bridal Makeup Course",
    level: "For aspiring artists",
    duration: "5 Days · Intensive",
    tagline: "From passion to profession.",
    copy: "A complete foundation in professional bridal artistry — technique, client experience and the confidence to build your own practice.",
    learn: [
      "HD & airbrush base techniques",
      "Traditional and modern bridal looks",
      "Draping & hairstyling fundamentals",
      "Consultation, pricing and kit building",
    ],
    img: "https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?q=85&w=900&auto=format&fit=crop",
    alt: "Makeup artist applying makeup during a professional training session",
  },
];

export const FAQS = [
  {
    q: "How far in advance should I book?",
    a: "Wedding dates — especially October to February — fill quickly. Enquiring 3–6 months ahead is ideal, but if your date is sooner, ask anyway: if the date is open, it's yours.",
  },
  {
    q: "HD or Airbrush — which finish is right for me?",
    a: "It depends on your skin, your venue and how long the celebration runs. HD gives a skin-like, camera-perfect finish; airbrush is feather-light and exceptionally long-wearing. We decide together during your consultation.",
  },
  {
    q: "Do you offer a trial before the wedding?",
    a: "Yes — a preview session can be arranged before your event, so we can refine your look, test products on your skin and remove every trace of wedding-day guesswork.",
  },
  {
    q: "Do you travel to venues or destination weddings?",
    a: "Absolutely. On-location services are available across the city, and destination weddings can be arranged — travel and stay are simply planned into your quote.",
  },
  {
    q: "How long does makeup take on the day?",
    a: "A bridal look typically takes around 2 to 2.5 hours, unhurried. Guest, family and party looks take about 45–60 minutes per person.",
  },
  {
    q: "Can you get my family and bridesmaids ready too?",
    a: "Yes — family and friends makeup is one of my favourite parts of a wedding morning. For larger parties, trusted artists assist so everyone is ready on time.",
  },
  {
    q: "How is my date confirmed?",
    a: "Send an inquiry with your date and details. I'll reply personally with availability; your date is reserved only after we speak and the booking is confirmed directly — nothing is automatic.",
  },
];
